import { Vector3 } from "three";
import { availableFeatures } from "./content.types";

export interface IFeatureLight {
  pos: Vector3;
  lookAt: Vector3;
  intensity: number;
  distance?: number;
  angle?: number;
  decay?: number;
  penumbra?: number;
}

export interface IFeatureData {
  [name: string]: {
    active: boolean;
    lastEditedTime: string;
    coordinates: {
      desktop: { pos: Vector3; lookAt: Vector3 };
      mobile?: { pos: Vector3; lookAt: Vector3 };
    };
  };
}
/*
    To get propper coordinates please use: CameraManager.getCurrentPosAndTarget();
    It will return both values that must be added to the respective vectors in EXTERNAL_AVAILABLE_FEATURES item:
       featureStoredPosition = coordinates.pos 
       featureStoredLookAt = coordinates.lookAt 
*/
export const EXTERNAL_AVAILABLE_FEATURES: IFeatureData = {
  [availableFeatures.rodas]: {
    active: true,
    lastEditedTime: "",
    coordinates: {
      desktop: {
        pos: new Vector3(3.1878606414416626, -0.5192808016660878, 1.7740445654059878),
        lookAt: new Vector3(-0.1008327035727278, -0.40197028091250575, 1.5958464383649518),
      },
      mobile: {
        pos: new Vector3(3.9145709059897613, -0.6052936856292597, 1.483320756491877),
        lookAt: new Vector3(0.016868662702109145, -0.46131790555132546, 1.3756941292791416),
      },
    },
  },
  [availableFeatures.farolGrade]: {
    active: true,
    lastEditedTime: "",
    coordinates: {
      desktop: {
        pos: new Vector3(-0.04050364759510593, 0.3267555206510892, 4.990762809810824 ),
        lookAt: new Vector3(0.013502213854203953, -0.20841313683513746, 0),
      },
      mobile: {
        pos: new Vector3(-0.6006261837391497, 0.14313590426384815, 6.191154631620376),
        lookAt: new Vector3(-0.6386918241483504, -0.1307375834886883, 0.004394805447054341),
      },
    },
  },
  [availableFeatures.lanternaTraseira]: {
    active: true,
    lastEditedTime: "",
    coordinates: {
      desktop: {
        pos: new Vector3(1.266502315345662, 0.2859055196909134, -3.9975495465279973),
        lookAt: new Vector3(0.6508542676792439, -0.019149170960488217, 0.09644746053962566),
      },
      mobile: {
        pos: new Vector3(1.5930293301181573, 0.38071498620238053, -4.341562945094708),
        lookAt: new Vector3(-0.2018789464220649, 0.03144680287068172, -0.02201586424814983),
      },
    },
  },
  [availableFeatures.biTone]: {
    active: true,
    lastEditedTime: "",
    coordinates: {
      desktop: {
        pos: new Vector3(4.984540735908894, 0.5243945694688319, -1.1683217068444542 ),
        lookAt: new Vector3(-0.12392497123376436, 0.2191347742858291, -0.5985166386682407),
      },
      mobile: {
        pos: new Vector3(5.258647494516702, 0.6399829115542885, -1.4697039052441938),
        lookAt: new Vector3(-0.3389191646745641, 0.10194520256268855, -1.331017817531742),
      },
    },
  },
  [availableFeatures.tetoSolar]: {
    active:true,
    lastEditedTime: "",
    coordinates: {
      desktop: { pos: new Vector3(3.2395667338649683, 2.5678628542476805, 3.0312849746083117), lookAt: new Vector3(-0.28153562310208263, 0.6336597047020726, 0) },
      mobile: { pos: new Vector3(3.698371654744602, 2.9785638219033257, 3.6065781140279807), lookAt: new Vector3(-0.0661348349644482, 0.3738183725470491, -0.36726567878297767) },
    },
  },
  [availableFeatures.soleira]: {
    active:true,
    lastEditedTime: "",
    coordinates: {
      desktop: {
        pos: new Vector3( 1.5721178641423383, -0.45673123969168306, -1.4593727006854182),
        lookAt: new Vector3( 0.5992299350681561, -0.38173580457643064, 0.611968372371248),
      },
      mobile: {
        pos: new Vector3( 2.4970519446349058, -0.12158097655846156, -3.2747304188251203),
        lookAt: new Vector3( 0.5057417116690399, -0.3077715749812752, 0.5389732235091279),
      },
    },
  },
  [availableFeatures.retrovisor]: {
    active:true,
    lastEditedTime: "",
    coordinates: {
      desktop: { pos: new Vector3(1.1206489197965186, 0.33720700133638276, 1.0926758193337498 ), lookAt: new Vector3(0.13230931101322085, 0.0013932580398426867, 0) },
      mobile: { pos: new Vector3(1.1206489197965186, 0.33720700133638276, 1.0926758193337498 ), lookAt: new Vector3(0.13230931101322085, 0.0013932580398426867, 0) },
    },
  },
  [availableFeatures.coluna]: {
    active:true,
    lastEditedTime: "",
    coordinates: {
      desktop: { pos: new Vector3(1.0754771133308003, 0.674347341818206, -1.786553017333752), lookAt: new Vector3(-0.433412206190177, 0.017426525404240317, 0 ) },
      mobile: { pos: new Vector3(1.8770724837334691, 0.8707768950765559, -3.2878751580648453), lookAt: new Vector3(-0.20548443228564586, 0.10773546609304563, -0.015165910159145405) },
    },
  },
  [availableFeatures.assinaturaDeDesign]: {
    active: true,
    lastEditedTime: "",
    coordinates: {
      desktop: { pos: new Vector3(0.9939912325986733, 0.4003552933335321, 5.090505699548235), lookAt: new Vector3(-0.11219729153946295, -0.10313905030184028, 0.032171516928781285) },
      mobile: { pos: new Vector3(1.2061174084002244, 0.513555314474907, 5.5423474950431615), lookAt: new Vector3(0.43755025276178433, 0.033172402448781745, -0.08081849500592847) },
    },
  },
  
};

export const INTERNAL_AVAILABLE_FEATURES: IFeatureData = {
  [availableFeatures.telas]: {
    active: true,
    lastEditedTime: "",
    coordinates: {
      desktop: { pos: new Vector3(0.21745011070655673, 0.8921259632990847, -2.1416161392038355), lookAt: new Vector3(0.032512754595757656, 0.5074881237619971, 0) },
      mobile: { pos: new Vector3(0.21745011070655673, 0.8921259632990847, -2.1416161392038355), lookAt: new Vector3(0.032512754595757656, 0.5074881237619971, 0) },
    },
  },
  [availableFeatures.somBose]: {
    active: true,
    lastEditedTime: "",
    coordinates: {
      desktop: { pos: new Vector3(-3.395894308900664, 0.17471084993688624, -0.6207127298464026), lookAt: new Vector3(0.032512754595757656, 0.5074881237619971, 0 ) },
      mobile: { pos: new Vector3(-3.395894308900664, 0.17471084993688624, -0.6207127298464026), lookAt: new Vector3(0.032512754595757656, 0.5074881237619971, 0) },
    },
  },

};

const externalLen = Object.keys(EXTERNAL_AVAILABLE_FEATURES).length;
const internalLen = Object.keys(INTERNAL_AVAILABLE_FEATURES).length;
export const TOTAL_FEATURES = {
  external: externalLen,
  externalActive: 0,
  internal: internalLen,
  internalActive: 0,
  all: internalLen + externalLen,
}
